var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { APIPermissions, BaseUserDto } from "./user.dtos";
import { IsDate, IsEnum, IsOptional, IsString, IsNumber, ValidateNested } from "class-validator";
export class APIKeyDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], APIKeyDto.prototype, "id", void 0);
__decorate([
    IsString()
], APIKeyDto.prototype, "name", void 0);
__decorate([
    IsString()
], APIKeyDto.prototype, "apiKey", void 0);
__decorate([
    IsEnum(APIPermissions, { each: true })
], APIKeyDto.prototype, "permissions", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], APIKeyDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => BaseUserDto),
    IsOptional()
], APIKeyDto.prototype, "createdBy", void 0);
export class APIKeyCreationDto {
}
__decorate([
    IsString()
], APIKeyCreationDto.prototype, "apiKey", void 0);
__decorate([
    IsString()
], APIKeyCreationDto.prototype, "apiSecret", void 0);
export class APIKeysResult {
}
__decorate([
    IsNumber()
], APIKeysResult.prototype, "total", void 0);
__decorate([
    Type(() => APIKeyDto),
    ValidateNested({ each: true })
], APIKeysResult.prototype, "results", void 0);
